import * as Sentry from '@sentry/react';
import { del, get, post, URLs } from './request';

export class ClientTokenException extends Error {
  constructor(error) {
    super(error);
    this.name = 'ClientTokenException';
  }
}

export const getClientToken = async () => {
  const response = await get({
    url: `${URLs.api}/checkout/client-token?platform=web`,
  }).catch((error) => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      throw new ClientTokenException(
        error.response.data?.errors || `Unknown client token server error ${error}`
      );
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      throw new ClientTokenException(`No response recieved from client-token ${error.request}`);
    } else {
      // Something happened in setting up the request that triggered an Error
      throw new ClientTokenException(
        error?.message || `Unknown client token client error ${error}`
      );
    }
  });
  const {
    data: { stripe_api_key, stripe_publishable_key, token },
  } = response;
  return { stripeApiKey: stripe_api_key, stripePublishableKey: stripe_publishable_key, token };
};

export const getPaymentMethods = async (userId) => {
  try {
    const {
      data: { payment_methods },
    } = await get({
      url: `${URLs.makomo}/api/payment_methods`,
    });
    return payment_methods;
  } catch (e) {
    Sentry.captureException(new PaymentMethodException(userId, e));
    throw e;
  }
};

export const postPaymentMethod = async ({ methodId }) => {
  const {
    data: { payment_methods },
  } = await post({
    url: `${URLs.makomo}/api/payment_methods?stripe_payment_method_id=${methodId}`,
  });
  return payment_methods;
};

export const delPaymentMethod = async ({ identifier, processor, country }) => {
  await del({
    url: `${URLs.makomo}/api/payment_methods/${identifier}?processor=${processor}&country=${country}`,
  });
};

class PaymentMethodException extends Error {
  constructor(userId, sourceError) {
    super(`Error retrieving payment methods for user [${userId}]: ${sourceError.message}`);
    this.name = 'PaymentMethodException';
  }
}
